import { useEffect, useRef } from 'react';
import { X } from '../../theme/icons.js';
import { IconButton } from './Button.js';
import './Sheet.css';

export function Sheet({ open, onClose, title, children, width = 520, accentColor }) {
  const panelRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => e.key === 'Escape' && onClose();
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [open, onClose]);

  useEffect(() => {
    if (!open) return;
    // Wer hat das Sheet geöffnet? Die fokussierte Auslosetaste (oder das
    // fokussierte Feld) bekommt beim Schließen den Fokus zurück - sonst
    // landet die Tastatur nach dem Escape auf <body> und die nächste
    // Tab-Tour beginnt am Seitenanfang (Audit B1, P2).
    const trigger = document.activeElement;
    if (panelRef.current) panelRef.current.focus();
    return () => {
      if (trigger && trigger.isConnected && typeof trigger.focus === 'function') {
        trigger.focus();
      }
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="sheet-overlay" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
      <div
        className="sheet-panel"
        style={{ '--sheet-width': `${width}px`, '--sheet-accent': accentColor || 'transparent' }}
        ref={panelRef}
        tabIndex={-1}
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        <div className="sheet-header">
          <h2 className="sheet-title">{title}</h2>
          {/* Derselbe Icon-Knopf wie in der Werkzeugleiste — vorher ein eigener,
              36 px runder Knopf, die vierte Icon-Button-Größe der Oberfläche
              und unter der Berührfläche (Audit A2, C2). */}
          <IconButton
            variant="standard"
            className="sheet-close"
            icon={<X size={20} />}
            label="Schließen"
            onClick={onClose}
          />
        </div>
        <div className="sheet-body">{children}</div>
      </div>
    </div>
  );
}
